import { useQuery } from '@tanstack/react-query';

import { useAuth } from 'context/AuthContext';
import { getDebtorsRequest } from '@/api';

function useGetDebtors() {
  const { isAuthenticated } = useAuth();
  return useQuery({
    queryKey: ['debtors'],
    queryFn: () => getDebtorsRequest(),
    enabled: isAuthenticated,
    select: (data) => data.data, // Вибираємо тільки дані з відповіді
  });
}

export default useGetDebtors;
